export const HomeSectionsTableColumns = [
    {
        id: "titleEn",
        labelEn: "Title (EN)",
        labelAr: "العنوان (EN)",
    },
    {
        id: "titleAr",
        labelEn: "Title (AR)",
        labelAr: "العنوان (AR)",
    },
    {
        id: "type",
        labelEn: "Type",
        labelAr: "النوع",
        align: "center",
    },
    {
        id: "code",
        labelEn: "Code",
        labelAr: "الكود",
        align: "center",
    },
    {
        id: "isActive",
        labelEn: "Status",
        labelAr: "الحالة",
        align: "center",
    },
    {
        id: "createdAt",
        labelEn: "Created At",
        labelAr: "تاريخ الإنشاء",
    },
];
